import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import slugify from 'react-slugify'

import { fetchAvailability, selectAvailabilityBySku } from 'Catalog/Availability/ducks'

class Tagging extends Component {
  constructor (props) {
    super(props)

    this.state = {
      sendGTM: false
    }
  }
  addDataLayerTransition () {
    setTimeout(() => {
      window.dataLayer = window.dataLayer || []
      window.dataLayerTransition = window.dataLayerTransition || undefined
      if (window.dataLayerTransition) {
        /* eslint-disable */
        for (var [key, item] of Object.entries(window.dataLayerTransition)) {
          window.dataLayer.push({
            'event': 'productImpressions',
            'eventCategory': 'enhanced-ecommerce',
            'eventAction': 'productImpression',
            'ecommerce': {
              'impressions': item
            }
          })
        }
        /* eslint-enable */
      }
    }, 5000)
  }
  addDataLayer (productSku, productName, productPrice, productIdentifier, originalId, vendorId, productPosition, categoryName) {
    this.setState({ sendGTM: true })

    window.dataLayer = window.dataLayer || []

    if (this.props.type === 'view') {
      window.dataLayerTransition = window.dataLayerTransition || {}
      const dataLayerTransition = window.dataLayerTransition
      const nameProps = slugify(productIdentifier, { delimiter: ' ' })
      const arrayTransition = [{
        'name': slugify(productName, { delimiter: ' ' }),
        'id': productSku,
        'price': productPrice ? productPrice.price : undefined,
        'metric2  ': productPrice && productPrice.cash ? productPrice.cash.price.toFixed(2) : undefined,
        'position': productPosition + 1,
        'category': categoryName ? slugify(categoryName, { delimiter: ' ' }) : undefined,
        'list': slugify(productIdentifier, { delimiter: ' ' })
      }]

      if (dataLayerTransition[nameProps]) {
        var item = dataLayerTransition[nameProps].find(item => item.id === productSku)
        if (!item) {
          window.dataLayerTransition = {
            [nameProps]: dataLayerTransition[nameProps] ? dataLayerTransition[nameProps].concat(arrayTransition) : dataLayerTransition[nameProps]
          }
        }
      } else {
        window.dataLayerTransition = {
          [nameProps]: arrayTransition
        }
      }
    }
    if (this.props.type === 'click') {
      window.dataLayer.push({
        'event': 'productClick',
        'eventCategory': 'enhanced-ecommerce',
        'eventAction': 'productClick',
        'ecommerce': {
          'click': {
            'actionField': { 'list': slugify(productIdentifier, { delimiter: ' ' }) },
            'products': [{
              'metric2': productPrice && productPrice.cash ? productPrice.cash.price.toFixed(2) : undefined,
              'name': slugify(productName, { delimiter: ' ' }),
              'id': productSku,
              'price': productPrice ? productPrice.price : undefined,
              'category': categoryName ? slugify(categoryName, { delimiter: ' ' }) : undefined,
              'position': productPosition + 1
            }]
          }
        }
      })
    }

    if (this.props.type === 'viewProduct') {
      window.dataLayer.push({
        'event': 'productDetail',
        'eventCategory': 'enhanced-ecommerce',
        'eventAction': 'productDetail',
        'ecommerce': {
          'detail': {
            'products': [{
              'metric2': productPrice && productPrice.cash ? productPrice.cash.price.toFixed(2) : undefined,
              'name': slugify(productName, { delimiter: ' ' }),
              'id': productSku,
              'price': productPrice ? productPrice.price : undefined,
              'category': categoryName ? slugify(categoryName, { delimiter: ' ' }) : undefined
            }]
          }
        }
      })
    }
    if (this.props.type === 'clickProduct') {
      window.dataLayer.push({
        'event': 'addToCart',
        'eventCategory': 'enhanced-ecommerce',
        'eventAction': 'addToCart',
        'ecommerce': {
          'add': {
            'products': [{
              'metric2': productPrice && productPrice.cash ? productPrice.cash.price.toFixed(2) : undefined,
              'name': slugify(productName, { delimiter: ' ' }),
              'id': productSku,
              'price': productPrice ? productPrice.price : undefined,
              'category': categoryName ? slugify(categoryName, { delimiter: ' ' }) : undefined,
              'quantity': '1'
            }]
          }
        }
      })
    }
  }

  render () {
    if (this.props.type === 'send') {
      this.addDataLayerTransition()
    } else if (this.state.sendGTM === false && this.props.price) {
      let nameShowcase = ''

      if (this.props.categoryName !== '') {
        nameShowcase = this.props.identifier + ' - ' + this.props.categoryName + ' - ' + this.props.titleShowcase
      } else {
        nameShowcase = this.props.identifier + ' - ' + this.props.titleShowcase
      }
      let productIdentifier = slugify(nameShowcase, { delimiter: ' ' })
      this.addDataLayer(this.props.sku, this.props.name, this.props.price, productIdentifier, this.props.originalId, this.props.vendorId, this.props.position, this.props.categoryName)
    }
    return ''
  }
}

Tagging.propTypes = {
  sku: PropTypes.string,
  originalId: PropTypes.string,
  vendorId: PropTypes.string,
  price: PropTypes.object,
  name: PropTypes.string,
  identifier: PropTypes.string,
  titleShowcase: PropTypes.string,
  categoryName: PropTypes.string,
  position: PropTypes.string,
  type: PropTypes.string
}

Tagging.defaultProps = {
  titleShowcase: '',
  categoryName: ''
}
const mapStateToProps = (state, props) => {
  const Availability = selectAvailabilityBySku(state, props)
  return Availability || {}
}

const mapDispatchToProps = dispatch => ({
  loadAvailability: (sku, originalId, vendorId) =>
    dispatch(fetchAvailability(sku, originalId, vendorId))
})

export default connect(mapStateToProps, mapDispatchToProps)(Tagging)



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductCard/Tagging.js